import _config from "./config.json";
const config = _config;
function isLocale(s) {
  return s in config;
}
export {
  config,
  isLocale
};
